/* 🤖 this file was generated by svg-to-ts */
export const matIconInventory2: {
  name: 'inventory-2';
  data: string;
} = {
  name: 'inventory-2',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-1 18H5V9h14v11zm1-13H4V4h16v3z"/><path d="M9 12h6v2H9z"/></svg>`
};
